import React, { useEffect, useState } from 'react'
import { checkPermission, generateRandomId, getDropdownIdsFromSelectArray } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import EmprConfigHeaderCard from 'views/pages/manage/masters/studentFinancials/epmrConfigs/EpmrConfigHeader';
import { getDropdowns, hardcodeDropdown, openInNewTab } from '../../common/services';
import { successToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import styles from '../../refundStyles.module.scss'
import EmptyListPlaceholder from 'views/pages/manage/masters/studentFinancials/epmrConfigs/EmptyListPlaceHolder';
import ALoader from 'views/pages/manage/common/a-loader';
import ConfigSummaryCard from './ConfigSummaryCard';
import AddEditConfigDialog from './addEditConfigDialog/AddEditConfigDialog';
import { fetchBusinessAreasByUnitType } from 'views/pages/manage/academicPlanAndTest/constant/common';
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import APopover from "views/pages/manage/common/a-popover";
import { createConfig, getConfigs, getFilterReqObj, getFormattedRefundConfig, updateConfig, REFUND_CONFIG_FILTER_FORM_FIELDS, getBuAgainstBuTypes } from './services';
import { getFilterCount } from 'views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant';
import FilterForm from './FilterForm';
import { DIGITAL_BUSINESS_IDS } from 'views/pages/manage/common/hook/useCashierOfficeDropdown'


const RefundsApprovalConfigListing = ({ userPermissions }) => {
  const isCreatePermission = checkPermission(userPermissions, "C");
  const isUpdatePermission = checkPermission(userPermissions, 'U');
  const isDeletePermission = checkPermission(userPermissions, 'D');

  const [form, setForm] = useState(null);
  const [refundsApprovalConfig, setRefundsApprovalConfig] = useState([]);
  const [dropdownData, setDropdownData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterCount, setFilterCount] = useState(getFilterCount);
  const [filterForm, setFilterForm] = useState({
    ...REFUND_CONFIG_FILTER_FORM_FIELDS,
  });
  const [buLoading, setBuLoading] = useState(false);

  const handleForm = (key, value) => setForm(prev => ({ ...prev, [key]: value }));
  const addEditConfigDialogOpen = !!form;

  const closeAddEditConfigDialog = () => {
    setForm(null);
    setDropdownData(prev => ({
      ...prev,
      businessAreas: []
    }))
  }

  console.log("form---", form);

  const addConfigHandler = () => setForm({
    isNew: true,
    approvalConfigNumber: generateRandomId() % 1000,
    approvalSettingDTO: []
  });

  const getAllRefundsConfig = async (dropdowns = dropdownData, filters = filterForm) => {
    try {
      setLoading(true);
      const resp = await getConfigs(getFilterReqObj(filters, dropdowns?.allActiveBu));
      const refundConfigs = resp?.data ?? [];
      setRefundsApprovalConfig(getFormattedRefundConfig(refundConfigs, dropdowns));
    } catch (e) {
      console.log(e);
    }
    finally {
      setLoading(false);
    }
  }

  const init = async () => {
    try {
      setLoading(true);
      const dropdownData = await getDropdowns();
      setDropdownData(dropdownData);
      getAllRefundsConfig(dropdownData)
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);

    }
  }

  const deleteConfigHandler = async (id) => {
    try {
      setLoading(true);
      const resp = '';
      if (resp?.code === 200) {
        successToast("Request completed successfully!");
        getAllRefundsConfig();
      }

    } catch (err) {
      console.log(err);

    } finally {
      setLoading(false);
    }
  }

  const createUpdateConfigHandler = async () => {
    try {
      setLoading(true);

      let payload = { ...form };

      const resp = await (form?.isNew ? createConfig(payload) : updateConfig(payload));

      if (resp?.code === 200) {
        successToast("Request completed successfully!");
        getAllRefundsConfig();
        closeAddEditConfigDialog();
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };



  const handleFilterForm = (key, val) => setFilterForm(prev => ({ ...prev, [key]: val }));

  const removeFilterHandler = async () => {
    await getAllRefundsConfig(dropdownData, {});
    setFilterForm({});
  }

  const applyFilterHandler = () => {
    getAllRefundsConfig(dropdownData, filterForm);
  };

  const buTypeChangeHandler = async (selectedBranchType) => {
    try {
      handleForm("branchType", [selectedBranchType]);

      let buAgainstBranchTypes = [];

      const branchTypeValue = typeof selectedBranchType?.label === "string"
        ? selectedBranchType?.label?.toLowerCase()
        : null;
      if (branchTypeValue === "advance") {
        buAgainstBranchTypes = dropdownData?.advanceBusinessAreas ?? [];
      } else if (selectedBranchType) {
        buAgainstBranchTypes = await getBuAgainstBuTypes(selectedBranchType, setBuLoading);
        buAgainstBranchTypes = buAgainstBranchTypes?.filter(bu => !DIGITAL_BUSINESS_IDS?.includes(bu?.label))
      }

      handleForm("businessArea", []);
      setDropdownData(prev => ({
        ...prev,
        businessAreas: buAgainstBranchTypes
      }));

    } catch (err) {
      console.error(err);
    }
  };

  const editConfigHandler = async config => {
    try {
      setForm({
        ...config,
        approvalConfigNumber: config?.approvalSettingDTO[0]?.approvalConfigNumber
      });
      let buAgainstBranchTypes = [];

      const branchTypeValue = typeof config?.branchType[0]?.label === "string"
        ? config?.branchType[0]?.label.toLowerCase()
        : null;

      if (branchTypeValue === "advance") {
        buAgainstBranchTypes = dropdownData?.advanceBusinessAreas ?? [];
      } else if (config?.branchType) {
        buAgainstBranchTypes = await getBuAgainstBuTypes(config?.branchType, setBuLoading);
        buAgainstBranchTypes = buAgainstBranchTypes?.filter(bu => !DIGITAL_BUSINESS_IDS?.includes(bu?.label))
      }

      setDropdownData(prev => ({
        ...prev,
        businessAreas: buAgainstBranchTypes
      }));
    } catch (err) {
      console.error(err);
    }
  }

  useEffect(() => {
    init();
  }, [])

  return (
    <>
      {loading && <ALoader position="fixed" />}

      <EmprConfigHeaderCard
        addConfigHandler={addConfigHandler}
        isCreatePermission={isCreatePermission}
        heading='Refunds approval Config'
      />

      <div className="d-flex justify-content-between my-3 mx-3">
        <div>
          <h4 className='className="color-black"'>{refundsApprovalConfig?.length} Configs</h4>
        </div>
        <div className="d-flex justify-content-between">
          <AButton
            variant="outline"
            onClick={() => { openInNewTab('refundSetup/refundsApprovalConfig/logs') }}
            size="xs"
          >
            Logs
          </AButton>
          <APopover
            buttonComponent={(onClick, styles) => (
              <AButton
                className="tiny-semi-bold color-dark"
                onClick={onClick}
                variant="outline"
                size="xs"
                updatedStyle={{
                  minWidth: "61px",
                  ...(filterCount > 0
                    ? {
                      border: "1px solid #00B0F5",
                      color: "#00B0F5",
                    }
                    : styles),
                }}
              >
                Filter {filterCount > 0 && <>( {filterCount} )</>}
              </AButton>
            )}
            menuComponent={(closePopup) => (
              <FilterForm
                closePopup={closePopup}
                dropdownData={dropdownData}
                filterForm={filterForm}
                filterCount={filterCount}
                setFilterCount={setFilterCount}
                setFilterForm={setFilterForm}
                applyFilterHandler={applyFilterHandler}
                handleFilterForm={handleFilterForm}
                removeFilterHandler={removeFilterHandler}

              />
            )}
          />
        </div>
      </div>

      {refundsApprovalConfig?.length > 0 ?
        <div className={`p-3 ${styles['config-cards-container']}`}>
          {refundsApprovalConfig?.map((config, index) =>
            <ConfigSummaryCard
              key={index}
              config={config}
              deleteConfigHandler={deleteConfigHandler}
              editConfigHandler={editConfigHandler}
              isUpdatePermission={isUpdatePermission}
              isDeletePermission={isDeletePermission}
            />)}
        </div>
        :
        <EmptyListPlaceholder
          addConfigHandler={addConfigHandler}
          isCreatePermission={isCreatePermission}
          title='Click here to add first configuration for student refund' />
      }

      <AddEditConfigDialog
        open={addEditConfigDialogOpen}
        handleClose={closeAddEditConfigDialog}
        form={form}
        setForm={setForm}
        handleForm={handleForm}
        dropdownData={dropdownData}
        createUpdateConfigHandler={createUpdateConfigHandler}
        buTypeChangeHandler={buTypeChangeHandler}
        buLoading={buLoading}
        loading={loading}
        setLoading={setLoading}
      />
    </>
  )
}

export default RefundsApprovalConfigListing;